;(function () {
  const LS_KEY = 'gt_quote_items';
  const API_URL = 'https://discount.gtsimulators.com/submit-quote';
  const productCache = new Map();

  /* ---------- localStorage helpers ---------- */
  const getQuoteItems = () =>
    JSON.parse(localStorage.getItem(LS_KEY) ?? '[]');

  const saveQuoteItems = items =>
    items.length
      ? localStorage.setItem(LS_KEY, JSON.stringify(items))
      : localStorage.removeItem(LS_KEY);

  /* ---------- product fetch + cache ---------- */
  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const res = await fetch(`/products/${handle}.json`);
    if (!res.ok) throw new Error('Failed to fetch product ' + handle);
    const product = (await res.json()).product;
    productCache.set(handle, product);
    return product;
  }

  /* ---------- build modal once ---------- */
  const modalContainer = document.createElement('div');
  modalContainer.id = 'quote-modal';
  modalContainer.setAttribute('role', 'dialog');
  modalContainer.setAttribute('aria-modal', 'true');
  modalContainer.innerHTML = `
    <div class="qr-backdrop"></div>
    <div class="qr-box" tabindex="-1">
      <div class="qr-header">
        <h2>Request a Quote</h2>
        <p>Fill out the form and we will get back to you as soon as possible.</p>
        <button type="button" class="qr-close" aria-label="Close">&times;</button>
      </div>
      <div class="qr-body" style="margin: 0px 20px;">
        <div class="qr-products">
          <table>
            <thead><tr><th></th><th>Product</th><th>Quantity</th></tr></thead>
            <tbody id="qr-items"></tbody>
          </table>
          <div class="d-none qr-emptyimg" style="z-index: 999; text-align: center; padding: 30px;">
            <img src="https://www.gtsimulators.com/cdn/shop/files/emptycart.png?v=10029400842675690053">
            <div>Your quote cart is empty.</div>
            <div class="qr-note">Continue shopping to add products.</div>
          </div>
        </div>
        <form class="qr-form">
          <div style="border-bottom: 0px; font-size:20px; font-weight:600">Your information</div>
          <div></div>
          <input id="qr-name"    type="text"  placeholder="Full Name" required>
          <input id="qr-email"   type="email" placeholder="Email" required>
          <input id="qr-company" type="text"  placeholder="Company">
          <input id="qr-phone"   type="tel"   placeholder="Phone" required>
          <input id="qr-address" type="text"  placeholder="Street Address" required>
          <input id="qr-city"    type="text"  placeholder="City" required>
          <input id="qr-state"   type="text"  placeholder="State" required>
          <input id="qr-zip"     type="text"  placeholder="Zip Code" required>
          <input id="qr-country" type="text"  placeholder="Country" required>
          <textarea id="qr-comments" rows="3" placeholder="Comments"></textarea>
          <input id="qr-files" name="files" type="file" style="display:none">
          <button id="qr-upload" class="qr-upload">Upload File (optional)</button>
          <div id="qr-error" class="qr-error" role="alert"></div>
        </form>
      </div>
      <div class="qr-footer">
        <button type="button" class="qr-continue">Continue Shopping</button>
        <div class="qr-search">
            <input id="qr-search-input" type="text"
                   placeholder="Or search products by name..." autocomplete="off">
            <ul id="qr-search-results" class="qr-search-results"></ul>
        </div>
        <button id="qr-submit" class="g-recaptcha qr-submit" data-sitekey="6Lek1UAUAAAAAHayLm3E9wQWLDOeZFBm_o3mKQYL" data-callback="onReCaptchaSuccess" data-size="invisible">
          <i class="icon-right-circle"></i> Submit Request
        </button>
      </div>
    </div>`;
  document.body.appendChild(modalContainer);

// valid "picked" selector (works for radios/checkboxes and <select> options)
const DPO_PICKED = 'input:checked, option:checked:not([value=""])';


/* ---- DPO helpers (required once) ---- */
function dpoRequiredLists(root = document) {
  const dpo = root.querySelector('#itoris_dynamicproductoptions');
  if (!dpo) return [];
  return Array.from(dpo.querySelectorAll('.options-list[validation*="required"]'));
}
function isDpoValid(root = document) {
  return dpoRequiredLists(root).every(list =>
    !!list.querySelector(DPO_PICKED)
  );
}
function paintDpoErrors(root = document) {
  // inject minimal styles once
  if (!document.getElementById('dpo-advice-style')) {
    const s = document.createElement('style');
    s.id = 'dpo-advice-style';
    s.textContent = `
      .dpo-error { outline: 0; }
      .dpo-error .field.choice { outline: 0; }
      .validation-advice {
        margin-top: 6px; font-size: 12px; color: #c62828; display: none;
      }
    `;
    document.head.appendChild(s);
  }

  let firstBad = null;

  dpoRequiredLists(root).forEach(list => {
    const ok = !!list.querySelector('input:checked, option:checked:not([value=""])');

    // create advice if missing
    let advice = list.parentElement.querySelector('.validation-advice');
    if (!advice) {
      advice = document.createElement('div');
      advice.className = 'validation-advice';
      advice.setAttribute('role', 'alert');
      advice.textContent = '⚠ Select an option above!';
      list.parentElement.appendChild(advice);
    }

    list.classList.toggle('dpo-error', !ok);
    list.setAttribute('aria-invalid', String(!ok));
    advice.style.display = ok ? 'none' : 'block';

    if (!ok && !firstBad) firstBad = list;
  });

  return firstBad;
}

// keep DPO warnings live-updated as the user picks options
const __dpoRoot = document.querySelector('#itoris_dynamicproductoptions');
if (__dpoRoot) {
  __dpoRoot.addEventListener('change', () => paintDpoErrors(document), true);
}



/* --- Max-length UI: red border + inline note --- */
function attachMaxLengthUI(scope) {
  // inject styles once
  if (!document.getElementById('qr-maxlen-style2')) {
    const s = document.createElement('style');
    s.id = 'qr-maxlen-style2';
    s.textContent = `
      .qr-form input.qr-at-max,
      .qr-form textarea.qr-at-max {
        border-color: #d33 !important;
        box-shadow: 0 0 0 1px #d33 inset;
      }
      /* the note sits inside the field area, bottom-right */
      .qr-maxnote {
        position: absolute;
        right: 10px;
        bottom: 6px;
        font-size: 11px;
        line-height: 1;
        color: #d33;
        display: none;
        pointer-events: none;
        background: transparent;
        z-index: 1;
      }
    `;
    document.head.appendChild(s);
  }

  const fields = scope.querySelectorAll('.qr-form input, .qr-form textarea');

  fields.forEach(input => {
    const limit = input.maxLength; // -1 if none
    if (!limit || limit < 0) return;

    // ensure we have a positioned wrapper
    const wrap = input.closest('.qr-field-wrapper') || input.parentElement;
    if (getComputedStyle(wrap).position === 'static') {
      wrap.style.position = 'relative';
    }

    // one note per field
    let note = wrap.querySelector(`.qr-maxnote[data-for="${input.id}"]`);
    if (!note) {
      note = document.createElement('div');
      note.className = 'qr-maxnote';
      note.setAttribute('data-for', input.id || '');
      // message shown when the limit is hit
      note.textContent = `Max ${limit} characters`;
      wrap.appendChild(note);
    }

    const apply = () => {
      const atMax = input.value.length >= limit;
      input.classList.toggle('qr-at-max', atMax);
      note.style.display = atMax ? 'block' : 'none';
    };

    input.addEventListener('input', apply);
    input.addEventListener('change', apply);
    requestAnimationFrame(apply); // initial (incl. autofill)
  });
}

  /* --- Max-length visual cue (no layout shift) --- */
  function attachMaxLengthBorder(scope) {
    // inject styles once
    if (!document.getElementById('qr-maxlen-style')) {
      const s = document.createElement('style');
      s.id = 'qr-maxlen-style';
      s.textContent = `
        .qr-form input.qr-at-max,
        .qr-form textarea.qr-at-max {
          border-color: #d33 !important;
          box-shadow: 0 0 0 1px #d33 inset; /* crisp red edge without moving layout */
        }
      `;
      document.head.appendChild(s);
    }

    const fields = scope.querySelectorAll('.qr-form input, .qr-form textarea');

    const apply = el => {
      const limit = el.maxLength; // -1 if none
      if (!limit || limit < 0) {
        el.classList.remove('qr-at-max');
        return;
      }
      el.classList.toggle('qr-at-max', el.value.length >= limit);
    };

    fields.forEach(el => {
      el.addEventListener('input',  () => apply(el));
      el.addEventListener('change', () => apply(el));
      requestAnimationFrame(() => apply(el)); // initial check (incl. autofill)
    });
  }

  /* ---------- element refs ---------- */
  const itemsBody  = modalContainer.querySelector('#qr-items');
  const submitBtn  = modalContainer.querySelector('#qr-submit');
  const nameInput  = modalContainer.querySelector('#qr-name');
  const emailInput = modalContainer.querySelector('#qr-email');
  const companyInput  = modalContainer.querySelector('#qr-company');
  const errorBox   = modalContainer.querySelector('#qr-error');
  const fileInput  = modalContainer.querySelector('#qr-files');
  const uploadBtn  = modalContainer.querySelector('#qr-upload');
  companyInput.maxLength = 41;
  modalContainer.querySelector('#qr-address').maxLength = 41;
  nameInput.maxLength = 33;
  
  attachMaxLengthBorder(modalContainer);
  attachMaxLengthUI(modalContainer);

  /* ---- Disable Add to Quote until DPO required fields are satisfied ---- */
(function initDpoQuoteGuard(){
  const root = document;
  const btn  = root.querySelector('.add-to-quote-btn');
  const dpo  = root.querySelector('#itoris_dynamicproductoptions');
  if (!btn || !dpo) return;

  const syncBtn = () => {
    const ok = isDpoValid(root);
    btn.classList.toggle('disabled', !ok);              // visual only
    btn.setAttribute('aria-disabled', String(!ok));     // a11y hint
  };

  syncBtn();
  dpo.addEventListener('change', syncBtn, true);
})();



  /* ---------- guard reCAPTCHA script ---------- */
  submitBtn.addEventListener('click', e => {
    e.preventDefault();
    e.stopImmediatePropagation(); 
    
    const form  = modalContainer.querySelector('.qr-form');
    if (!form.checkValidity()) {          // browser evaluates all “required” fields
      form.reportValidity();              // shows the native tooltip(s)
      return;                             // stop here until user fixes the fields
    }
    if (getQuoteItems().length === 0) {   // no products → don’t bother with captcha
      errorBox.textContent = 'Add at least one product before submitting.';
      errorBox.focus();
      return;
    }

    
    // 1. Is the Google script present and initialised?
    if (!(window.grecaptcha && grecaptcha.execute)) {
      errorBox.textContent =
        'Submission failed: your network is blocking our security check. Contact your IT or switch networks and try again.';
      errorBox.focus();
      return;                                   // do NOT fall through
    }
    // 2. Run the invisible challenge
    grecaptcha.execute();                       // will call onReCaptchaSuccess(...)
  });


  /* ---------- modal helpers ---------- */
  function openModal() {
    renderItems();
    errorBox.textContent = '';
    modalContainer.classList.add('active');
    modalContainer.querySelector('.qr-box').focus();
    document.addEventListener('keydown', onKeyDown);
  }
  function closeModal() {
    modalContainer.classList.remove('active');
    document.removeEventListener('keydown', onKeyDown);
  }
  function onKeyDown(e) { if (e.key === 'Escape') closeModal(); }
  modalContainer
    .querySelectorAll('.qr-close, .qr-backdrop, .qr-continue')
    .forEach(el => el.addEventListener('click', closeModal));

  /* ---------- file picker ---------- */
  function resetFile() {
    fileInput.value = '';
    uploadBtn.textContent = 'Upload File (optional)';
  }
  
  /* one button = two roles */
  uploadBtn.addEventListener('click', e => {
    e.preventDefault();
    fileInput.files.length ? resetFile() : fileInput.click();
  });
  
  fileInput.addEventListener('change', () => {
    if (fileInput.files.length > 1) {              // keep only first file
      const dt = new DataTransfer();
      dt.items.add(fileInput.files[0]);
      fileInput.files = dt.files;
    }
    uploadBtn.textContent = fileInput.files.length ? 'File uploaded (remove)' : 'Upload File (optional)';
  });


    /* ---------- show “filled” label on each field ---------- */
  const formFields = modalContainer.querySelectorAll('.qr-form input, .qr-form textarea');
  formFields.forEach(field => {
    // wrap each field in a relative container
    const wrapper = document.createElement('div');
    wrapper.className = 'qr-field-wrapper';
    wrapper.style.position = 'relative';
    field.parentNode.insertBefore(wrapper, field);
    wrapper.appendChild(field);

    // create the floating label
    const lbl = document.createElement('span');
    lbl.className = 'qr-field-label';
    lbl.textContent = field.getAttribute('placeholder');
    Object.assign(lbl.style, {
      position: 'absolute',
      top: '-15px',
      left: '0px',
      fontSize: '10px',
      color: '#999',
      display: 'none',
      background: 'white',
      padding: '0 10px'
    });
    
    wrapper.appendChild(lbl);

    // toggle it whenever the user types
    field.addEventListener('input', () => {
      lbl.style.display = field.value.trim() ? 'block' : 'none';
    });
  });

  

  /* ---------- form validation ---------- */
  function validateForm() {
    const hasItems   = getQuoteItems().length > 0;
    const validInputs = nameInput.checkValidity() && emailInput.checkValidity();
    const ok = hasItems && validInputs;
    // submitBtn.disabled = !ok;
    submitBtn.classList.toggle('enabled', ok);
  }

  nameInput.addEventListener('input', validateForm);
  emailInput.addEventListener('input', validateForm);

  /* ---------- render items ---------- */
  function renderItems() {
    const items = getQuoteItems() 
    itemsBody.innerHTML = '';
    getQuoteItems().forEach(item => {
      const tr = document.createElement('tr');
      tr.dataset.pid = item.productId;
      tr.dataset.vid = item.variantId;

      tr.innerHTML = `
        <td>
          <a href="/products/${item.handle}" target="_blank">
            <img src="${item.image}" alt="${item.title}">
          </a>
        </td>
        <td>
        <a href="/products/${item.handle}" target="_blank">
          ${item.sku
            ? `<div class="qr-sku" style="color:#999;font-weight: 400;font-size: 14px;margin-bottom: 3px;">
                 ${item.sku}
               </div>`
            : ''}
          <div class="qr-title">
            ${item.title}
          </div>
          </a>
        </td>
        <td>
          <div class="qty-control">
            <button data-action="dec" data-pid="${item.productId}" data-vid="${item.variantId}">–</button>
            <span>${item.qty}</span>
            <button data-action="inc" data-pid="${item.productId}" data-vid="${item.variantId}">+</button>
            <button data-action="rem" data-pid="${item.productId}" data-vid="${item.variantId}">
              <i class="icon-trash-empty"></i>
            </button>
          </div>
        </td>`;

      itemsBody.appendChild(tr);
    })
    // show or hide the “empty” image
    const emptyImgEl = modalContainer.querySelector('.qr-emptyimg')
    if (items.length === 0) {
      emptyImgEl.classList.remove('d-none')
    } else {
      emptyImgEl.classList.add('d-none')
    }
    validateForm();
  }

  /* ---------- qty / remove delegation ---------- */
  itemsBody.addEventListener('click', e => {
    const btn = e.target.closest('button[data-action]');
    if (!btn) return;

    const pid = btn.dataset.pid;
    const vid = btn.dataset.vid;
    let items = getQuoteItems();
    const item = items.find(it => it.productId == pid && it.variantId == vid);

    switch (btn.dataset.action) {
      case 'dec': if (item && item.qty > 1) item.qty--; break;
      case 'inc': if (item) item.qty++; break;
      case 'rem': {
        items = items.filter(it => !(it.productId == pid && it.variantId == vid));
        saveQuoteItems(items);

        const tr = btn.closest('tr');
        tr.style.opacity = '0';
        tr.style.transition = 'opacity .25s ease';
        tr.addEventListener('transitionend', () => {
          tr.remove();
          if (!items.length) renderItems();
        }, { once:true });
        return;
      }
    }
    saveQuoteItems(items);
    renderItems();
  });

  /* ---------- submit handler ---------- */
  // The original submitBtn click listener has been removed.
  // Replaced by the onReCaptchaSuccess(token) callback below.

  /* ---------- reCAPTCHA callback ---------- */
  window.onReCaptchaSuccess = async function(token) {
    const form = modalContainer.querySelector('.qr-form');

    // 1. stop if invalid
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // 2. lock UI
    submitBtn.disabled  = true;
    submitBtn.textContent = 'Sending…';
    errorBox.textContent = '';

    try {
      // 3. build detailed items
      const detailed = await Promise.all(
        getQuoteItems().map(async i => {
          let p, v, priceD, totalD;
          try {
            p = await fetchProduct(i.handle);
            v = p.variants.find(vv => String(vv.id) === String(i.variantId)) || {};
            priceD = v.price ? parseFloat(v.price) : 0;
            totalD = priceD * i.qty;
          } catch {
            p = { id:'', title:i.title, images:[{src:i.image}], vendor:'', handle:'' };
            v = { id:i.variantId, title:'', sku:i.variantId, price:0 };
            priceD = totalD = 0;
          }
          return {
            id: p.id,
            title: i.title, 
            image: p.images[0]?.src || '',
            vendor: p.vendor,
            handle: p.handle,
            quantity: i.qty,
            variant: {
              id: v.id || '',
              title: v.title && v.title !== 'Default Title' ? v.title : '',
              price: priceD,
              basePrice: priceD,
              sku: i.sku || v.sku || '',
              priceText: `$${priceD.toFixed(2)}`
            },
            message: '',
            total: totalD,
            totalPrice: `$${totalD.toFixed(2)}`,
            trackingSource: '',
            properties: i.properties || [],
            pageChoosen: 'product',
            priceCountDiscount: Math.round(totalD * 100),
            currencyShop: '${{amount}}',
            tags: p.tags ? p.tags.split(',').map(t => t.trim()) : [],
            offer_price: ''
          };
        })
      );

      // 4. build payload, including the reCAPTCHA token
      const payload = {
        product_list: detailed,
        customer_info: [
          { label: 'Full name',  value: nameInput.value.trim() },
          { label: 'Email',      value: emailInput.value.trim() },
          { label: 'Company',    value: companyInput.value.trim() },
          { label: 'Phone',      value: modalContainer.querySelector('#qr-phone').value.trim() },
          { label: 'Street Address', value: modalContainer.querySelector('#qr-address').value.trim() },
          { label: 'City',       value: modalContainer.querySelector('#qr-city').value.trim() },
          { label: 'State',      value: modalContainer.querySelector('#qr-state').value.trim() },
          { label: 'Zip Code',   value: modalContainer.querySelector('#qr-zip').value.trim() },
          { label: 'Country',    value: modalContainer.querySelector('#qr-country').value.trim() },
          { label: 'Comments',   value: modalContainer.querySelector('#qr-comments').value.trim() },
          { label: 'Are you Tax Exempt?', value: '' }
        ],
        created_at: new Date().toISOString(),
        recaptcha_token: token
      };

      // 5. send to our Flask endpoint, including uploaded files
      const form = new FormData();
      form.append('payload', JSON.stringify(payload));
      Array.from(fileInput.files).forEach(f => form.append('files', f, f.name));
      
      const res = await fetch(API_URL, {
        method: 'POST',
        body: form
      });


      if (!res.ok) throw new Error(await res.text());

      // 6. on success, clear and show confirmation
      localStorage.removeItem(LS_KEY);
      modalContainer.querySelector('.qr-box').innerHTML = `
        <div class="qr-success">
          <svg class="qr-check" viewBox="0 0 52 52" aria-hidden="true">
            <circle cx="26" cy="26" r="24"></circle>
            <polyline points="14 28 22 34 38 18"></polyline>
          </svg>
          <h2>Thank you for submitting a quote request!</h2>
          <p><br>You should hear back from us within 24-48 business hours.
             <br>If you have any questions in the meantime please
             <a href="/pages/contact-us" style="text-decoration:underline;color:#3668cb;">contact us</a>.
          </p>
          <button class="qr-btn qr-shop" id="qr-shop">Continue Shopping</button>
          <button class="qr-btn qr-new"  id="qr-new">Request a New Quote</button>
        </div>`;

        const resetQuote = () => {
          localStorage.removeItem(LS_KEY);
          window.location.reload();
        };

        const shopBtn = document.getElementById('qr-shop');
        if (shopBtn) shopBtn.addEventListener('click', resetQuote);
        const newBtn = document.getElementById('qr-new');
        if (newBtn) newBtn.addEventListener('click', resetQuote);


    } catch (err) {
      errorBox.textContent  = 'Sorry, could not send your quote.';
      submitBtn.disabled    = false;
      submitBtn.textContent = 'Submit Request';
      console.error(err);
    }
  };

  function cdnSize(url, size = '100x') {
    if (!url) return '';
    return url.replace(/(?:_(\d+x\d*(?:_crop_[^._]+)?|\d+x))?(\.[a-z0-9]+)(\?.*)?$/i, `_${size}$2$3`);
  }

  function getVariantImage(product, variant) {
    // 1) Variant’s own featured image (Shopify exposes this for many themes)
    const vImg = variant?.featured_image?.src;
    if (vImg) return vImg;

    // 2) If you have image IDs on variants, match them
    if (variant?.image_id && Array.isArray(product?.images)) {
      const hit = product.images.find(img => String(img.id) === String(variant.image_id));
      if (hit?.src) return hit.src;
    }

    // 3) Fall back to the *currently shown* product image in the DOM
    const domImg = document.querySelector('#product-featured-image')?.getAttribute('src');
    if (domImg) return domImg;

    // 4) Last resort: product’s first image
    return product?.images?.[0]?.src || '';
  }


  /* ---------- Add-to-Quote button handler (UPDATED) ---------- */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.add-to-quote-btn');
    if (!btn) return;
    e.preventDefault();
    
    // ---- DPO required gate: show same “⚠ Select an option above!” and stop ----
    const firstBad = paintDpoErrors(document);
    if (firstBad) {
      firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    try {
      // 1) figure out main product + quantity
      const root = btn.closest('.product-button') || document;
      const handle  = btn.dataset.handle;
      const qty     = +(
        btn.dataset.qty
        || root.querySelector('input[name="quantity"]')?.value
        || 1
      );

      // 2) resolve the CURRENT variant id (don’t trust the button’s data attribute)
      let variantId = new URLSearchParams(location.search).get('variant') || null;

      const hiddenSelect = root.querySelector('select[name="id"]');
      if (!variantId && hiddenSelect && hiddenSelect.value) {
        variantId = hiddenSelect.value;
      }


      // 3) fetch the product JSON (we’ll use it if we need fallback)
      const product = await fetchProduct(handle);

      // 4) if hiddenSelect didn’t yield a value, FALL BACK to the visible <select data-option="…">
      if (!variantId) {
        // a) grab all <select class="single-option-selector" data-option="optionN">
        const optionSelects = Array.from(
          root.querySelectorAll('select.single-option-selector')
        ).filter(sel => sel.hasAttribute('data-option'));

        // b) sort by data-option (“option1”, “option2”, etc.)
        optionSelects.sort((a, b) => {
          const ia = parseInt(a.getAttribute('data-option').replace('option', ''), 10) || 0;
          const ib = parseInt(b.getAttribute('data-option').replace('option', ''), 10) || 0;
          return ia - ib;
        });

        // c) read their .value (e.g. "Arm", "Leg" / "Light", "Dark")
        const selectedValues = optionSelects.map(sel => sel.value);

        // d) find the matching variant (even if sold‐out)
        const match = product.variants.find(variant => {
          return selectedValues.every((val, idx) => {
            return String(variant[`option${idx + 1}`]) === String(val);
          });
        });

        if (match && match.id) {
          variantId = String(match.id);
        }
      }

      // 5) if we still have no variantId, show an alert and bail
      if (!variantId) {
        alert('Could not determine which variant is selected. Please try again.');
        btn.disabled = false;
        return;
      }
// keep the button in sync for future clicks
btn.dataset.variantId = String(variantId);


// 6) find (or fake) the variant object
let variant = product.variants.find(v => String(v.id) === String(variantId));

if (!variant) {                                        // simple product: fabricate
  variant = {
    id:    variantId || '',
    title: '',
    sku:   product.variants[0]?.sku || ''              // e.g. “ETXY-HYSTERO”
  };
}
// helper: guaranteed fallback for the main SKU
const fallbackSku = variant.sku || product.variants[0]?.sku || '';

// 7) build / merge the quote-cart entry
const items    = getQuoteItems();
const existing = items.find(i => i.productId == product.id && i.variantId == variant.id);

/* gather any DPO <select> choices */
const optionPicks = Array.from(
  root.querySelectorAll('#itoris_dynamicproductoptions select.product-custom-option')
).map(sel => {
  const opt = sel.options[sel.selectedIndex];
  return opt && opt.value ? opt.textContent.trim() : null;     // “o. ETH7-HYP/2G”
}).filter(Boolean);

/* include a real variant title (e.g. “7 Weeks”) if this product has one */
const variantLabel =
  variant.title && variant.title !== 'Default Title' ? variant.title : '';

/* build the final display title */
const extras     = variantLabel ? [variantLabel, ...optionPicks] : optionPicks;
const fullTitle  = product.title + (extras.length ? ', ' + extras.join(', ') : '');

if (existing) {
  existing.qty   += qty;
  existing.title  = fullTitle;                // update if options changed
} else {
  const chosenImage = getVariantImage(product, variant);
  items.push({
    productId: product.id,
    variantId: variant.id,
    title:     fullTitle,
    qty,
    image:     cdnSize(chosenImage, '100x'),
    handle,
    sku:       variant.sku || fallbackSku
  });
}


      // ── NOW ALSO CAPTURE ANY CHECKED DPO OPTIONS ────────────────────────────────
      const optionInputs = Array.from(
        document.querySelectorAll(
          '#itoris_dynamicproductoptions .itoris-dynamicoptions-list-images ' +
          '.field.choice input.product-custom-option:checked'
        )
      );

      for (const cb of optionInputs) {
        const url = cb.getAttribute('product-url');
        if (!url) continue;

        // extract handle & variant from the URL
        const [path, query] = url.split('?');
        const optHandle     = path.split('/products/')[1];
        const params        = new URLSearchParams(query);
        const optVariantId  = params.get('variant');

        // fetch the full product JSON
        const optProduct    = await fetchProduct(optHandle);
        // find the matching variant (fallback to the first)
        const optVariant    =
          optProduct.variants.find(v => String(v.id) === optVariantId) ||
          optProduct.variants[0] ||
          {};

        const optQty  = 1;
        const optId   = String(optVariant.id || cb.value);

        // merge if already in list
        const existingOpt = items.find(i => i.variantId === optId);
        if (existingOpt) {
          existingOpt.qty += optQty;
        } else {
          items.push({
            productId:  optProduct.id,
            variantId:  optId,
            title:      optProduct.title + (optVariant.title ? ` — ${optVariant.title}` : ''),
            qty:        optQty,
            image:      optVariant.featured_image?.src || optProduct.images[0]?.src || '',
            handle:     optHandle,
            sku:        optVariant.sku || '',
          });
        }
      }
      // ─────────────────────────────────────────────────────────────────────────

      saveQuoteItems(items);
      openModal();
    } catch (err) {
      console.error(err);
      alert('Could not add to quote.');
    } finally {
      btn.disabled = false;
    }
  });

  /* ---------- open modal from header ---------- */
  document.addEventListener('click', e => {
    const headerLink = e.target.closest('.cart-target .rfq-header');
    const footerLink = e.target.closest('a[href="/apps/request-a-quote"]')
    if (!headerLink && !footerLink) return
    e.preventDefault();
    openModal();
  });



   /* ---------- add entire cart to quote ---------- */
  const cartToQuoteBtn = document.getElementById('cart-add-to-quote');
  if (cartToQuoteBtn) {
    cartToQuoteBtn.addEventListener('click', async e => {
      e.preventDefault();
      cartToQuoteBtn.disabled = true;
      try {
        // 1. get live cart JSON
        const res = await fetch('/cart.js');
        if (!res.ok) throw new Error('Cart fetch failed');
        const cart = await res.json();

        // 2. merge each line item into localStorage
        const items = getQuoteItems();
        for (const c of cart.items) {
          const handle    = c.handle;
          const variantId = String(c.variant_id);
          const qty       = c.quantity;
          const product   = await fetchProduct(handle);
          const variant   = product.variants.find(v => String(v.id) === variantId) || product.variants[0];

          const exist = items.find(i => i.variantId === variantId);
          if (exist) {
            exist.qty += qty;
          } else {
            items.push({
              productId: product.id,
              variantId,
              title:     product.title + (variant.title && variant.title !== 'Default Title'
                          ? ` — ${variant.title}` : ''),
              qty,
              image:     (variant.featured_image?.src || product.images[0]?.src)
                         .replace(/(\.\w+)(\?.*)?$/, '_100x$1'),
              handle,
              sku:       variant.sku || ''
            });
          }
        }
        saveQuoteItems(items);
        openModal();
      } catch (err) {
        console.error(err);
        alert('Could not add cart items to quote.');
      } finally {
        cartToQuoteBtn.disabled = false;
      }
    });
  }


  
  // ── QUICK SEARCH FEATURE (with real SKU & price) ─────────────────────
  const searchInput = modalContainer.querySelector('#qr-search-input');
  const resultsList = modalContainer.querySelector('#qr-search-results');
  let   searchTimer;

  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) {
      resultsList.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(async () => {
      try {
        // 1) pull the top 5 suggestions
        const resp = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}`);
        const json = await resp.json();
        const hints = (json.resources?.results?.products || []).slice(0, 5);
        if (!hints.length) {
          resultsList.innerHTML = '';
          return;
        }

        // 2) fetch full product JSONs for each handle
        const details = await Promise.all(
          hints.map(h => fetchProduct(h.handle))
        );

        // 3) build the <li> list with real SKU & price
        resultsList.innerHTML = hints.map((h, i) => {
          const prod      = details[i];
          const varId     = h.url.split('?variant=')[1] || String(prod.variants[0].id);
          const variant   = prod.variants.find(v => String(v.id) === varId) || prod.variants[0];
          const sku       = variant.sku || '';
          const price     = `$${parseFloat(variant.price).toFixed(2)}`;
          // build a direct product link (adjust if your theme URL differs)
          const productUrl = `/products/${h.handle}?variant=${variant.id}`;
        
          return `
            <li data-handle="${h.handle}" data-variant="${variant.id}">
              <img src="${h.image}" alt="${h.title}">
              <span class="qr-result-text">
                ${h.title}${sku ? ` (${sku})` : ''} — ${price}
              </span>
              <button
                type="button"
                class="qr-view-btn"
                onclick="window.open('${productUrl}', '_blank')"
                aria-label="View product">
                <i class="icon-eye-2"></i>
              </button>
            </li>`;
        }).join('');

      } catch (err) {
        console.error('Search error:', err);
      }
    }, 300);
  });

  resultsList.addEventListener('click', async e => {
    const li = e.target.closest('li[data-handle]');
    if (!li) return;
    const handle    = li.dataset.handle;
    let   variantId = li.dataset.variant;

    const prod = await fetchProduct(handle);
    if (!variantId) variantId = String(prod.variants[0]?.id || '');

    // re-use your Add-to-Quote logic to merge/increment
    const items    = getQuoteItems();
    const existing = items.find(i => i.handle === handle && i.variantId === variantId);

    if (existing) {
      existing.qty++;
    } else {
      const v = prod.variants.find(v => String(v.id) === variantId) || prod.variants[0];
      items.push({
        productId: prod.id,
        variantId,
        title:     prod.title + (v.title ? ` — ${v.title}` : ''),
        qty:       1,
        image:     v.featured_image?.src || prod.images[0]?.src || '',
        handle,
        sku:       v.sku || ''
      });
    }

    saveQuoteItems(items);
    renderItems();
    // clear the search
    resultsList.innerHTML = '';
    searchInput.value     = '';
  });
  // ───────────────────────────────────────────────────────────────────────

})();
